export const listCommunities = [
  {
    name: "General",
    flag: "🌏",
    countryCode: "GLOBAL",
  },
  {
    name: "Kardo",
    flag: require("../assets/logo.png"),
    countryCode: "KARDO",
  },
  {
    name: "Singapore",
    flag: "🇸🇬",
    countryCode: "SG",
  },
  {
    name: "United States",
    flag: "🇺🇸",
    countryCode: "US",
  },
  {
    name: "Japan",
    flag: "🇯🇵",
    countryCode: "JP",
  },
  {
    name: "India",
    flag: "🇮🇳",
    countryCode: "IN",
  },
  {
    name: "Hong Kong",
    flag: "🇭🇰",
    countryCode: "HK",
  },
  {
    name: "Australia",
    flag: "🇦🇺",
    countryCode: "AU",
  },
  {
    name: "United Arab Emirates",
    flag: "🇦🇪",
    countryCode: "AE",
  },
  {
    name: "United Kingdom",
    flag: "🇬🇧",
    countryCode: "GB",
  },
  {
    name: "Europe",
    flag: "🇪🇺",
    countryCode: "EU",
  },
  {
    name: "Canada",
    flag: "🇨🇦",
    countryCode: "CA",
  },
  {
    name: "Malaysia",
    flag: "🇲🇾",
    countryCode: "MY",
  },
];
